import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getData } from "../../../../services/library";

function AddHojaRuta(props) {
  const [alta, setAlta] = useState(props.alta);
  const [datosRow, setDatosRow] = useState({
    nombre: "",
    descripcion: "",
  });
  const [formValido, setFormValido] = useState(false);
  const [sucursales, setSucursales] = useState(null);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [vehiculos, setVehiculos] = useState(null);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState("");
  const [disbtn, setDisbtn] = useState(false);
  const [diasSeleccionados, setDiasSeleccionados] = useState({
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
  });
  // Días de la semana
  // Días de la semana con números (el lunes es el 1 y el sabado el 6)
  const diasSemana = [
    { id: "lunes", label: "Lunes", numero: 1 },
    { id: "martes", label: "Martes", numero: 2 },
    { id: "miercoles", label: "Miércoles", numero: 3 },
    { id: "jueves", label: "Jueves", numero: 4 },
    { id: "viernes", label: "Viernes", numero: 5 },
    { id: "sabado", label: "Sábado", numero: 6 },
  ];
  // Manejar cambio de días
  const handleDiasChange = (event) => {
    setDiasSeleccionados({
      ...diasSeleccionados,
      [event.target.name]: event.target.checked,
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) {
      props.onClose();
    }
  };


  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
  getData(
    "/sucursales/xsucauth/" + localStorage.getItem("suc_auth").split(","),
    setSucursales
  );
}, []);

useEffect(() => {
  if (sucursalSeleccionada && sucursalSeleccionada.id) {
    // Limpiar vehículo seleccionado cuando cambia la sucursal
    setVehiculoSeleccionado("");
    // Cargar vehículos de la sucursal seleccionada
    getData("/vehiculos/sucursal/" + sucursalSeleccionada.id, setVehiculos);
  } else {
    // Si no hay sucursal seleccionada, limpiar la lista de vehículos
    setVehiculos(null);
    setVehiculoSeleccionado("");
  }
}, [sucursalSeleccionada]);


  const guardarHoja = async (e) => {
    e.preventDefault();
    setDisbtn(true);
    // Validar que se haya seleccionado al menos un día
    const diasSeleccionadosArray = diasSemana.filter(
      (dia) => diasSeleccionados[dia.id]
    );


    try {
      // 1. Insertar la hoja de ruta principal
      const responseHoja = await fetch(UrlApi + "/envasado_hoja_ruta", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre: datosRow.nombre,
          descripcion: datosRow.descripcion,
          id_sucursal: sucursalSeleccionada.id,
          id_vehiculo: vehiculoSeleccionado.id,
          activo: 1,
          usuario: localStorage.getItem("user"),
        }),
      });

      const resultadoHoja = await responseHoja.json();

      if (!responseHoja.ok) {
        throw new Error(
          resultadoHoja.message || "Error al guardar la hoja de ruta"
        );
      }

      // Obtener el ID de la hoja recién creada
      const idHoja = resultadoHoja.id || resultadoHoja.insertId;

      if (!idHoja) {
        throw new Error("No se pudo obtener el ID de la hoja creada");
      }

      // 2. Insertar los días seleccionados en envasado_hoja_dias
      const insertsDias = diasSeleccionadosArray.map(async (dia) => {
        const responseDia = await fetch(UrlApi + "/envasado_hoja_dias", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_hoja: idHoja,
            dia: dia.numero,
            activo: 1,
          }),
        });

        if (!responseDia.ok) {
          throw new Error(`Error al guardar el día ${dia.label}`);
        }

        return responseDia.json();
      });

      // Esperar a que todos los inserts de días terminen
      await Promise.all(insertsDias);

      // Éxito
      console.log("Guardado exitoso");
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La Hoja de Ruta se guardó exitosamente!");
    } catch (err) {
      console.error("Error:", err.message);
      setOpenSnack(true);
      setColorMensaje("#FADBD8");
      setMensaje(err.message || "Error al guardar la hoja de ruta");
    }
  };

  useEffect(() => {
    const camposRequeridosCompletos =
      datosRow.nombre.trim() !== "" &&
      datosRow.descripcion.trim() !== "" &&
      sucursalSeleccionada;

    const alMenosUnDiaSeleccionado = Object.values(diasSeleccionados).some(
      (dia) => dia
    );

    setFormValido(camposRequeridosCompletos && alMenosUnDiaSeleccionado);
  }, [datosRow, sucursalSeleccionada, vehiculoSeleccionado, diasSeleccionados]);

  return (
    <>
      <Dialog fullWidth open={alta} onClose={() => handleClose()} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nueva Hoja de Ruta
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardarHoja}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={4} py={1} mb={1}>
                <TextField
                  label="Nombre"
                  name="nombre"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.nombre}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={8} py={1} mb={1}>
                <TextField
                  label="Descripción"
                  name="descripcion"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.descripcion}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <Autocomplete
                  disabled={!sucursales}
                  required
                  disableClearable
                  id="id_sucursal"
                  style={style}
                  size="small"
                  noOptionsText={"sucursal INEXISTENTE"}
                  options={sucursales || ""}
                  autoHighlight
                  getOptionLabel={(s) => s.id + "-" + s.nombre}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sucursalSeleccionada || null}
                  defaultValue={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar sucursal..."
                      {...params}
                      label="Sucursal"
                      focused
                      required
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <Autocomplete
                  disabled={!vehiculos}
                  required
                  disableClearable
                  id="id_vehiculo"
                  style={style}
                  size="small"
                  noOptionsText={"Vehículo INEXISTENTE"}
                  options={vehiculos || ""}
                  autoHighlight
                  getOptionLabel={(veh) =>
                    veh.nombre || veh.patente || veh.modelo || ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={vehiculoSeleccionado || null}
                  defaultValue={vehiculoSeleccionado || null}
                  onChange={(event, value) => {
                    setVehiculoSeleccionado(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.nombre || option.patente || option.modelo}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      placeholder="Tipee para buscar vehículo..."
                      {...params}
                      label="Vehículo"
                      focused
                      // required
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              {/* Selección de días */}
              <Grid item xs={12} py={1} mb={1}>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  fontWeight="500"
                  color="text.secondary"
                  sx={{ mb: 1.5, textAlign: "center" }}
                >
                  Días de la semana
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  {diasSemana.map((dia) => (
                    <Box
                      key={dia.id}
                      onClick={() =>
                        handleDiasChange({
                          target: {
                            name: dia.id,
                            checked: !diasSeleccionados[dia.id],
                          },
                        })
                      }
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 2,
                        py: 1,
                        border: 1.5,
                        borderColor: diasSeleccionados[dia.id]
                          ? "primary.main"
                          : "grey.300",
                        borderRadius: 2,
                        backgroundColor: "white",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          border: 1.5,
                          borderColor: diasSeleccionados[dia.id]
                            ? "primary.main"
                            : "grey.400",
                          backgroundColor: diasSeleccionados[dia.id]
                            ? "primary.main"
                            : "transparent",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {diasSeleccionados[dia.id] && (
                          <Box
                            sx={{
                              color: "white",
                              fontSize: "12px",
                              fontWeight: "bold",
                              lineHeight: 1,
                            }}
                          >
                            ✓
                          </Box>
                        )}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: diasSeleccionados[dia.id]
                            ? "primary.main"
                            : "text.primary",
                        }}
                      >
                        {dia.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid>
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  disabled={!formValido || disbtn}
                  // endIcon={<SaveIcon />}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AddHojaRuta;
